export class QuestionnaireProgress {
    public currentQuestionIndex: number;
    public totalQuestions: number;

    constructor(currentQuestionIndex: number, totalQuestions: number) {
        this.currentQuestionIndex = currentQuestionIndex;
        this.totalQuestions = totalQuestions;
    }
}
